import { apiClient } from './client';

export interface Bloc {
  id: number;
  bloc_kind: 'bloc' | 'avatar';
  source_bloc_id: number | null;
  avatar_color: string | null;
  object_name: string;
  inventory_number: string | null;
  scale_px_per_mm: number | null;
  description: string | null;
  remarks: string | null;
  fragment_emplacement: string | null;
  fragment_identification: string | null;
  poids_estime_kg: number | null;
  image_path: string;
  real_size_x_mm: number | null;
  real_size_y_mm: number | null;
  real_size_z_mm: number | null;
  image_width: number | null;
  image_height: number | null;
  composite_slug?: string | null;
  created_at: string;
  updated_at: string;
}

export interface CreateBlocDto {
  object_name: string;
  inventory_number?: string;
  scale_px_per_mm?: number;
  description?: string;
  remarks?: string;
  fragment_emplacement?: string | null;
  fragment_identification?: string | null;
  poids_estime_kg?: number | null;
  real_size_x_mm?: number;
  real_size_y_mm?: number;
  real_size_z_mm?: number;
  image_width?: number;
  image_height?: number;
}

export const blocsApi = {
  getAll: async (search?: string): Promise<Bloc[]> => {
    const params = search?.trim() ? { q: search.trim() } : {};
    const response = await apiClient.get<Bloc[]>('/api/blocs', { params });
    return response.data;
  },

  getById: async (id: number): Promise<Bloc> => {
    const response = await apiClient.get<Bloc>(`/api/blocs/${id}`);
    return response.data;
  },

  create: async (data: CreateBlocDto, image: File): Promise<Bloc> => {
    const formData = new FormData();
    formData.append('image', image);
    formData.append('data', JSON.stringify(data));

    const response = await apiClient.post<Bloc>('/api/blocs', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  update: async (id: number, data: Partial<CreateBlocDto>): Promise<Bloc> => {
    const response = await apiClient.put<Bloc>(`/api/blocs/${id}`, data);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await apiClient.delete(`/api/blocs/${id}`);
  },

  createAvatar: async (id: number, color: string): Promise<Bloc> => {
    const response = await apiClient.post<Bloc>(`/api/blocs/${id}/avatar`, { color });
    return response.data;
  },
};
